
import * as XLSX from "xlsx";
import React, { useState, useEffect } from "react";
import TooltipButton from "../../Button/TooltipButton";
import OrangeGradientButton from "../../Button/OrangeGradientButton";
import ExportExcelButton from "../../Button/ExportExcelButton";
import api from "../../../api/baseUrl";

import edidIcon from "../../../icons/edit.svg";
import deleteIcon from "../../../icons/trash.svg";
import viewIcon from "../../../icons/Property 1=broken (5).svg";
import Snackbar from "../../SnackBar/SnackBar";
import PrimaryButton from "../../Button/primaryButton/PrimaryButton";


import VisitorBulkUpload from "../../VisitorBulkUpload/ProductBulkUpload";
import SkeletonLoader from "../../SkeletonLoader/SkeletonLoader";
import NoData from "../../NoData/NoData.js";
const Modal = ({ isOpen, onClose, children, fullscreen = false }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className={`modal ${fullscreen ? "fullscreen" : ""}`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* <button className="modal-close" onClick={onClose}>✕</button> */}
                <button className="modal-close" onClick={onClose}>
                    ✕
                </button>
                {children}
            </div>
        </div>
    );
};




const TableMarketers = ({ marketers = [], refreshDataMarketers, title }) => {
    const [showModal, setShowModal] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [formData, setFormData] = useState({});
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [phoneError, setPhoneError] = useState("");

    const [shouldGroup] = useState(false);
    const [snackbar, setSnackbar] = useState({ message: "", type: "info" });


    const [currentPage, setCurrentPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);

    const [marketerSellers333, setMarketerSellers333] = useState();

    const [sellersCount, setSellersCount] = useState();

    const [pageProducts, setPageProducts] = useState({
        normalMessages: [],
        archiveMessages: [],
        pagesCount: 1,
    });

    const [activeTab, setActiveTab] = useState("active"); // "active" یا "archive"


    const [roleFilter, setRoleFilter] = useState("");      // فیلتر نقش
    const [roleDropdownOpen, setRoleDropdownOpen] = useState(false); // باز/بسته بودن dropdown

    const [searchQuery, setSearchQuery] = useState(""); // مقدار تایپ‌شده
    const [appliedSearch, setAppliedSearch] = useState(""); // مقداری که با Enter تأیید شده
    // const displayedMarketers = roleFilter
    //     ? marketers.filter((m) => m.role === roleFilter)
    //     : marketers;



    const [showNoData, setShowNoData] = useState(false);



    const displayedMarketers = (activeTab === "archive"
        ? pageProducts.archiveMessages
        : pageProducts.normalMessages
    ).filter(m => roleFilter ? m.role === roleFilter : true);





    const exportToExcel = () => {
        const data = marketerSellers333.map((m, index) => ({
            "ردیف": index + 1,
            "نام فروشگاه": m.seller_shop_name,
            "نام": m.seller_name,
            "نام خانوادگی": m.seller_family,
            "شماره موبایل": m.seller_phone,
            "تلفن ثابت": m.seller_landline,
            "استان": m.seller_province,
            "شهر": m.seller_city,
            "آدرس": m.seller_addr,
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "فروشگاه‌ها");

        XLSX.writeFile(workbook, "sellers.xlsx");
    };




    const fetchPage = async (page = 1, search = "") => {
        let timer;
        try {
            timer = setTimeout(() => setLoading(true), 1000);
            const data = await refreshDataMarketers(page, search, activeTab === "archive");
            if (!data) return;
            setPageProducts(data);
            setPagesCount(data.pagesCount || 1);
        } catch (err) {
            console.error("Error fetching page:", err);
        } finally {
            clearTimeout(timer);
            setLoading(false);
        }
    };


    const handleGetDataAllMarketers = async (page = 1) => {
        try {
            const result = await api.get("/get-marketers", { params: { page, limit: 1000 } });
            // setDataAllSeller(result.data.messages);
            return result.data.messages; // <-- برگرداندن داده‌ها برای اکسل
        } catch (error) {
            console.error("خطا:", error);
            alert("خطا در دریافت اطلاعات");
            return [];
        }
    };

    useEffect(() => {
        fetchPage(currentPage, appliedSearch);
    }, [currentPage, appliedSearch, activeTab]);

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > pagesCount) return;
        setCurrentPage(newPage);
    };



    useEffect(() => {
        if (!loading) {
            if (displayedMarketers.length === 0) {
                // کمی تاخیر قبل از نمایش NoData
                const timer = setTimeout(() => setShowNoData(true), 500);
                return () => clearTimeout(timer);
            } else {
                setShowNoData(false);
            }
        }
    }, [loading, displayedMarketers]);



    // --- حالت مشاهده جزئیات ---
    const [viewingItem, setViewingItem] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [marketerAcsess, setMarketerAcsess] = useState(null);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const roleMap = {
        manager: "مدیر فروشگاه",
        bowner: "ادمین",
        marketer: "ویزیتور"
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        let body;

        if (editingItem) {
            // در حالت ویرایش
            body = {
                action: "update",
                id: editingItem.id,
                name: formData.name,
                surname: formData.surname,
                phone_number: formData.phone || "",
                address: formData.address || "",
                role: formData.role,
                access: {
                    brand: formData.brand || [],
                    // city: formData.city || [],
                },
            };
        } else {
            // در حالت افزودن
            body = {
                action: "add",
                id: formData.national || "", // ← شناسه
                name: formData.name,
                surname: formData.surname,
                phone_number: formData.phone || "",
                address: formData.address || "",
                role: formData.role,

                access: {
                    brand: formData.brand || [],
                    // city: formData.city || [],
                },
            };
        }

        try {
            const result = await api.post("/crud-marketers", body);

            if (result.data.accepted === true) {
                setSnackbar({
                    title: "موفقیت",
                    description: editingItem
                        ? "ویزیتور با موفقیت آپدیت شد."
                        : "ویزیتور با موفقیت اضافه شد.",
                    type: "success"
                });

                fetchPage(currentPage, appliedSearch);
                setShowModal(false);
                setFormData({});
            }

        } catch (error) {
            console.error("خطا در ارسال داده:", error);
            setSnackbar({ title: "خطا", description: "خطا در ارسال داده", type: "error" });
        }
    };


    // const handleEditClick = (marketer) => {
    //     setEditingItem(marketer);
    //     setFormData({ ...marketer });
    //     setShowModal(true);
    // };

    const handleEditClick = (marketer) => {
        setEditingItem(marketer);

        // اطمینان از اینکه brand همیشه آرایه است
        const normalizedBrands = Array.isArray(marketer.access?.brand)
            ? marketer.access.brand
            : marketer.brand
                ? Array.isArray(marketer.brand)
                    ? marketer.brand
                    : typeof marketer.brand === "string"
                        ? marketer.brand.split(",").map(b => b.trim())
                        : []
                : [];

        setFormData({
            name: marketer.name || "",
            surname: marketer.surname || "",
            phone: marketer.phone || "",
            address: marketer.address || "",
            role: marketer.role || "",
            brand: normalizedBrands,
            id: marketer.id
        });

        setShowModal(true);
    };


    const handleDelete = async (id) => {
        try {
            const result = await api.post("/crud-marketers", { action: "delete", id });
            if (result.data.accepted === true) {

                setSnackbar({
                    title: "موفقیت",
                    description: "ویزیتور با موفقیت حذف شد .",
                    type: "success"
                });


                fetchPage(currentPage, appliedSearch);

            }









        } catch (error) {


            console.error("خطا در حذف:", error);
        }
    };
    const brandMapping = {
        'mishen': 'میشن',
        'troyshi': 'ترویشی', // یا 'ترویشی' - مطمئن شوید تلفظ درست است
        'jeyran': 'جیران',
    }



    // --- مشاهده جزئیات مارکتر ---
    const handleSeeDetails = async (id) => {


        try {
            const result = await api.post("/crud-marketers", { action: "get", id });
            setViewingItem(result.data.message[0]);


            const brands = result.data?.message?.[0]?.access?.brand ?? [];
            const persianBrandsString = brands
                .slice(0, 3)
                .map(b => brandMapping[b?.toLowerCase()?.trim()] || b)
                .filter(Boolean)
                .join(', ') || 'دسترسی خاصی ندارد';

            setMarketerAcsess(persianBrandsString);



            const marketerSellers = result.data?.message?.[0]?.sellers ?? [];
            const allsellersLenght = result.data?.message?.[0]?.sellersCount ?? [];

            setSellersCount(allsellersLenght)
            setMarketerSellers333(marketerSellers)


            setEditingItem(null);
            setModalOpen(true);
        } catch (error) {
            console.error("خطا در مشاهده:", error);
            setSnackbar({ message: "خطا در مشاهده", type: "error" });
        }
    };
    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setCurrentPage(1);
            setAppliedSearch(searchQuery.trim());
        }
    };




    return (
        <div className="">

            <div className="card-header">
                <h2 className="card-title">{title}</h2>

                <div className="header-actions">
                    <div className="search-container">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="جستجو بر اساس نام یا شناسه..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={handleSearchKeyDown}
                        />
                    </div>

                    <div className="button-group-header-card">
                        <ExportExcelButton fetchData={handleGetDataAllMarketers} />
                        <OrangeGradientButton
                            onClick={() => {
                                setEditingItem(null);
                                setFormData({});
                                setShowModal(true);
                            }}
                        >
                            افزودن ویزیتور
                        </OrangeGradientButton>

                    </div>
                </div>
            </div>



            <div className="table-container">

                <div className="tabs-container">
                    <button
                        className={`tab-button ${activeTab === "active" ? "active" : ""}`}
                        onClick={() => setActiveTab("active")}
                    >
                        فعال
                    </button>
                    <button
                        className={`tab-button ${activeTab === "archive" ? "active" : ""}`}
                        onClick={() => setActiveTab("archive")}
                    >

                        بایگانی</button>


                </div>



                {loading ? (
                    <SkeletonLoader rows={20} />
                ) : displayedMarketers.length > 0 ? (
                    <>
                        <table>
                            <thead>
                                <tr>
                                    <th>شناسه</th>
                                    <th>نام</th>
                                    <th className="responsive-title"><p>نام خانوادگی</p></th>
                                    <th>موبایل</th>
                                    <th style={{ position: "relative" }}>
                                        <div
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setRoleDropdownOpen((prev) => !prev)}
                                        >
                                            نقش ▾
                                        </div>

                                        {roleDropdownOpen && (
                                            <div className="role-dropdown">
                                                <div onClick={() => { setRoleFilter(""); setRoleDropdownOpen(false); }}>همه</div>
                                                <div onClick={() => { setRoleFilter("bowner"); setRoleDropdownOpen(false); }}>ادمین</div>
                                                <div onClick={() => { setRoleFilter("marketer"); setRoleDropdownOpen(false); }}>ویزیتور</div>
                                                <div onClick={() => { setRoleFilter("manager"); setRoleDropdownOpen(false); }}>مدیر فروشگاه</div>
                                            </div>
                                        )}
                                    </th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayedMarketers.map((m) => (
                                    <tr key={m.id}>
                                        <td>{new Intl.NumberFormat("fa-IR", { useGrouping: shouldGroup }).format(m.id)}</td>
                                        <td>{m.name}</td>
                                        <td>{m.surname}</td>
                                        <td>{m.phone}</td>
                                        <td>{roleMap[m.role] || m.role}</td>
                                        <td>
                                            <div className="button-group">
                                                <TooltipButton icon={edidIcon} alt="ویرایش" tooltipText="ویرایش" onClick={() => handleEditClick(m)} />
                                                <TooltipButton icon={viewIcon} alt="جزئیات" tooltipText="جزئیات" onClick={() => handleSeeDetails(m.id)} className="margin-btn" />
                                                <TooltipButton icon={deleteIcon} alt="حذف" tooltipText="حذف" onClick={() => { setDeleteItemId(m.id); setDeleteModalOpen(true); }} className="delete-btn margin-btn" />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {/* Pagination */}
                        <div className="pagination">
                            {/* قبلی */}
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>قبلی</button>

                            {Array.from({ length: pagesCount }, (_, i) => i + 1)
                                .filter((page) => page === 1 || page === pagesCount || (page >= currentPage - 1 && page <= currentPage + 1))
                                .map((page, idx, arr) => {
                                    const prev = arr[idx - 1];
                                    if (prev && page - prev > 1) {
                                        return (
                                            <React.Fragment key={page}>
                                                <span style={{ padding: "0 5px" }}>...</span>
                                                <button onClick={() => handlePageChange(page)} className={currentPage === page ? "active" : ""}>{page}</button>
                                            </React.Fragment>
                                        );
                                    }
                                    return (
                                        <button key={page} onClick={() => handlePageChange(page)} className={currentPage === page ? "active" : ""}>{page}</button>
                                    );
                                })}

                            {/* بعدی */}
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagesCount}>بعدی</button>
                        </div>
                    </>) : showNoData ? (
                        <div className="no-data-message">
                            <NoData message="هیچ فروشگاهی یافت نشد" />
                        </div>
                    ) : null}



            </div>


            {/* جدول لیست مارکترها */}

            {/* مودال افزودن/ویرایش */}
            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <h2 className="modal-title">
                    {editingItem ? "ویرایش ویزیتور" : "افزودن ویزیتور جدید"}
                </h2>
                <form className="modal-form" onSubmit={handleSubmit}>
                    <div className="form__input-group">
                        <input
                            type="text"
                            name="name"
                            placeholder=" "
                            value={formData.name || ""}
                            onChange={handleChange}
                            required
                            className="form__input"
                            maxLength={45}

                        />
                        <label className="form__input-label">نام ویزیتور</label>
                    </div>

                    <div className="form__input-group">
                        <input
                            type="text"
                            name="surname"
                            placeholder=" "
                            value={formData.surname || ""}
                            onChange={handleChange}
                            required
                            maxLength={45}

                            className="form__input"

                        />
                        <label className="form__input-label">نام خانوادگی ویزیتور</label>
                    </div>



                    {/* 
                    {!editingItem && (
            
                        <div className="form__input-group">
                            <input
                                type="text"
                                name="national"
                                placeholder=" "
                                value={formData.national || ""}
                                onChange={(e) => {
                                    // حذف تمام کاراکترهای غیرعددی
                                    let val = e.target.value.replace(/\D/g, "");

                                    // حذف صفرهای ابتدایی
                                    val = val.replace(/^0+/, "");

                                    // محدود به 8 رقم
                                    if (val.length > 8) val = val.slice(0, 8);

                                    handleChange({ target: { name: "national", value: val } });
                                }}
                                required
                                className="form__input"
                                inputMode="numeric"  // کیبورد موبایل عددی
                                maxLength={8}        // برای اطمینان در type="text"
                            />
                            <label className="form__input-label">شناسه ویزیتور</label>
                        </div>


                    )} */}


                    {/* ورودی شناسه */}
                    {!editingItem ? (
                        <div className="form__input-group">
                            <input
                                type="text"
                                name="national"
                                placeholder=" "
                                value={formData.national || ""}
                                onChange={(e) => {
                                    let val = e.target.value.replace(/\D/g, "");
                                    val = val.replace(/^0+/, "");
                                    if (val.length > 8) val = val.slice(0, 8);
                                    handleChange({ target: { name: "national", value: val } });
                                }}
                                required
                                className="form__input"
                                inputMode="numeric"
                                maxLength={8}
                            />
                            <label className="form__input-label">شناسه ویزیتور</label>
                        </div>
                    ) : (
                        <div className="form__input-group">
                            <input
                                type="text"
                                name="id"
                                placeholder=" "
                                value={formData.id || ""}
                                disabled
                                className="form__input"
                            />
                            <label className="form__input-label">شناسه ویزیتور</label>
                        </div>
                    )}



                    {/* <div className="form__input-group">
                        <input
                            type="tel"
                            name="phone"
                            placeholder=" "
                            value={formData.phone || ""}
                            onChange={(e) => {
                                let val = e.target.value.replace(/\D/g, ""); // فقط اعداد
                                val = val.replace(/^0+/, ""); // حذف صفرهای ابتدایی
                                if (val.length > 14) val = val.slice(0, 14); // محدودیت طول
                                handleChange({ target: { name: "phone", value: val } });
                            }}
                            maxLength={14}
                            className="form__input"
                            inputMode="numeric"
                        />
                        <label className="form__input-label">شماره تماس</label>
                    </div> */}



                    <div className="phone-input-container">
                        <div className="phone-input-wrapper">
                            <span className="phone-prefix">09</span>
                            <input
                                id="phone"
                                name="phone"
                                type="text"
                                className={`phone-input ${phoneError ? "has-error" : ""}`}
                                value={formData.phone?.slice(2) || ""}
                                placeholder=" "
                                required
                                maxLength={9}
                                onChange={(e) => {
                                    let val = e.target.value.replace(/\D/g, "");
                                    if (val.length > 9) val = val.slice(0, 9);

                                    setFormData((prev) => ({ ...prev, phone: "09" + val }));

                                    if (val.length < 9)
                                        setPhoneError("شماره تماس باید ۱۱ رقم باشد (مثل 09123456789)");
                                    else setPhoneError("");
                                }}
                            />
                            <label htmlFor="phone" className="phone-label">شماره تماس</label>
                        </div>

                        {phoneError && <span className="phone-error">{phoneError}</span>}
                    </div>


                    <div className="form__input-group">
                        <input
                            type="text"
                            name="address"
                            placeholder=" "
                            value={formData.address || ""}
                            onChange={handleChange}
                            required
                            maxLength={300}
                            className="form__input"
                        />
                        <label className="form__input-label">آدرس</label>
                    </div>
                    <div className="form__input-group">
                        <select
                            className="form__input"
                            name="role"
                            value={formData.role || ""}
                            onChange={handleChange}
                            required
                        >
                            <option value="" disabled hidden></option>
                            <option value="bowner">ادمین کل</option>
                            <option value="marketer">ویزیتور</option>
                            <option value="manager">مدیر</option>
                        </select>
                        <label className="form__input-label">نقش</label>
                    </div>

                    {/* انتخاب برندها */}
                    {/* انتخاب برندها */}
                    <div className="marketer-brand-select">
                        <label className="marketer-brand-select__label">انتخاب برندها</label>
                        <div className="marketer-brand-select__container">
                            {[
                                { label: "تروی", value: "تروی" },
                                { label: "جیران", value: "جیران" },
                                { label: "میشن", value: "میشن" },
                            ].map((brand) => (
                                <label key={brand.value} className="marketer-brand-select__item">
                                    <input
                                        type="checkbox"
                                        value={brand.value}
                                        checked={formData.brand?.includes(brand.value) || false}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setFormData((prev) => {
                                                const current = prev.brand || [];
                                                if (checked) {
                                                    return { ...prev, brand: [...current, brand.value] };
                                                } else {
                                                    return {
                                                        ...prev,
                                                        brand: current.filter((b) => b !== brand.value),
                                                    };
                                                }
                                            });
                                        }}
                                    />
                                    <span>{brand.label}</span>
                                </label>
                            ))}
                        </div>
                    </div>









                    {/* {!editingItem && (
                        <div className="form__input-group">
                            <select
                                className="form__input"
                                name="role"
                                value={formData.role || ""}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled hidden></option>
                                <option value="bowner">ادمین کل</option>
                                <option value="marketer">ویزیتور</option>
                                <option value="manager">مدیر</option>
                            </select>
                            <label className="form__input-label">نقش</label>
                        </div>
                    )} */}

                    <PrimaryButton
                        title={editingItem ? "ذخیره تغییرات" : "ذخیره ویزیتور"}
                        type="submit"
                        loading={loading}
                    />
                </form>

            </Modal>

            {/* مودال حذف */}
            {isDeleteModalOpen && (
                <Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
                    <h3 className="delete-modal-title">
                        آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟
                    </h3>
                    <div className="modal-buttons">
                        <button className="btn cancel-btn" onClick={() => setDeleteModalOpen(false)}>
                            انصراف
                        </button>
                        <button
                            className="btn confirm-btn"
                            onClick={() => {
                                handleDelete(deleteItemId);
                                setDeleteModalOpen(false);
                            }}
                        >
                            تایید
                        </button>
                    </div>
                </Modal>
            )}

            {/* مودال جزئیات مارکتر */}
            {modalOpen && viewingItem && (
                <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
                    <div className="modal-info-content">
                        <h3 className="modal-title">جزئیات ویزیتور</h3>
                        <div className="modal-info">
                            <div className="info-row">
                                <span className="info-label">نام:</span>
                                <span className="info-value">{viewingItem.name}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">نام خانوادگی:</span>
                                <span className="info-value">{viewingItem.surname}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">آدرس:</span>
                                <span className="info-value">{viewingItem.address}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">شماره تماس:</span>
                                <span className="info-value">{viewingItem.phone}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">شناسه:</span>
                                <span className="info-value">{viewingItem.id}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">نقش:</span>
                                <span className="info-value">
                                    {roleMap[viewingItem.role] || viewingItem.role}
                                </span>
                            </div>

                            <div className="info-row">
                                <span className="info-label">دسترسی های برند</span>
                                <span className="info-value">{marketerAcsess}</span>
                            </div>
                            <div className="info-row2">
                                <div className="info-header">
                                    <span className="info-label">فروشگاه‌های تعریف‌شده</span>

                                    <div className="header-actions">
                                        <button className="count-btn" disabled>
                                            {sellersCount} فروشگاه
                                        </button>

                                        <button
                                            className="excel-btn"
                                            onClick={exportToExcel}
                                        >
                                            خروجی اکسل
                                        </button>
                                    </div>
                                </div>


                                <div className="seller-list">
                                    {marketerSellers333.map((m) => (
                                        <div className="seller-row" key={m.id}>
                                            <div className="seller-name">
                                                <div className="seller-title">
                                                    {m.seller_shop_name}
                                                </div>

                                                <div className="seller-meta">
                                                    <span>
                                                        {m.seller_name} {m.seller_family}
                                                    </span>

                                                    <span className="dot">•</span>

                                                    <span>
                                                        {m.seller_province}، {m.seller_city}
                                                    </span>

                                                    {m.seller_phone && (
                                                        <>
                                                            <span className="dot">•</span>
                                                            <span>
                                                                {m.seller_phone}
                                                            </span>
                                                        </>
                                                    )}
                                                </div>

                                                {m.seller_addr && (
                                                    <div className="seller-address">
                                                        {m.seller_addr}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>





                        </div>
                    </div>
                </Modal>

            )}



            <Snackbar
                title={snackbar.title}
                description={snackbar.description}
                type={snackbar.type}
                duration={3500}
                onClose={() => setSnackbar({ title: "", description: "", type: "info" })}
            />

        </div>
    );
};

export default TableMarketers;
